import formatDate from '@sdk/utils/dateFormat/formatDate';
import getRealDate from '@sdk/utils/getRealDate';
import getNowDate from '@sdk/utils/getNowDate';
import { SHIFT } from '@sdk/schedule/constants';

import type {
  Event,
  NavigateToSchedule,
  ShowPublishShiftModal,
  ShowPublishShiftTooltip,
} from '../onboardingChecklist.types';
import { EventStatus } from '../onboardingChecklist.types';
import { SCHEDULE_PATH_NAME } from '../onboardingChecklist.consts';

import usePublishScheduleModal from './usePublishScheduleModal';
import usePublishScheduleTooltip from './usePublishScheduleTooltip';

type Props = {
  isLoaded: boolean;
  showPublishShiftModal: ShowPublishShiftModal;
  showPublishShiftTooltip: ShowPublishShiftTooltip;
  allEvents: Event[];
  navigateToSchedule: NavigateToSchedule;
};

const usePublishSchedule = ({
  isLoaded,
  showPublishShiftModal,
  showPublishShiftTooltip,
  allEvents,
  navigateToSchedule,
}: Props) => {
  const planningEvent = allEvents.find(
    ({ type, status }) => type === SHIFT && status === EventStatus.planning
  );
  const scheduleDate = planningEvent
    ? formatDate(getRealDate(planningEvent.dtstart))
    : formatDate(getNowDate());

  const { setTriggerPublishModallOn, setTriggerPublishModallOff, publishScheduleModalRef } =
    usePublishScheduleModal({
      isLoaded,
    });

  const { setTriggerPublishTooltipOn, setTriggerPublishTooltipOff } = usePublishScheduleTooltip({
    isLoaded,
    showPublishShiftTooltip,
  });

  const publishSchedule = () => {
    setTriggerPublishModallOff();
    setTriggerPublishTooltipOff();

    if (window.location.pathname === SCHEDULE_PATH_NAME) {
      if (planningEvent) {
        showPublishShiftModal();
        return;
      }

      publishScheduleModalRef.current?.open();
      return;
    }

    navigateToSchedule({ date: scheduleDate });

    if (!planningEvent) {
      setTriggerPublishModallOn();
    } else {
      setTriggerPublishTooltipOn();
    }
  };

  return { publishSchedule, publishScheduleModalRef };
};

export default usePublishSchedule;
